import React from 'react';

const PALETTE: [string, string][] = [
  ['#fbe2d6', '#cb4f30'],
  ['#dcebe2', '#1c5039'],
  ['#d2f5ee', '#166b63'],
  ['#fdf3d6', '#7a5300'],
  ['#e5eefb', '#15418b'],
  ['#f1f1ef', '#3d3b35'],
];

function hashName(name: string): number {
  let h = 0;
  for (const c of name) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return h;
}

interface AvatarProps {
  name?: string;
  src?: string;
  size?: number;
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ name = '?', src, size = 32, className = '' }) => {
  const initials = name
    .split(' ')
    .map(p => p[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  const [bg, fg] = PALETTE[hashName(name) % PALETTE.length];

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        width={size}
        height={size}
        className={`rounded-full object-cover flex-none ${className}`}
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full flex-none font-semibold ${className}`}
      style={{ width: size, height: size, background: bg, color: fg, fontSize: Math.round(size * 0.4), letterSpacing: '-0.02em' }}
    >
      {initials}
    </span>
  );
};

export default Avatar;
